export default function BulkCSV() {
  window.location.replace("https://utilities.odynn.com/importexport");
  return null;
}
